<template>
  <v-card class="panelBlock" v-if="chapterQuickLinks.length > 0 || isCommunityAdmin">
    <v-layout column>
      <v-flex>
        <h2>{{ chapterConstants.CHAPTER_QUICKLINKS }}</h2>
      </v-flex>

      <v-flex class="forum-quicklinks">
        <v-layout v-if="!isAddRecord" column class="chapter_quick_links__drag-div inner-scrollbar">
          <draggable
            :list="chapterQuickLinks"
            :options="{ animation: 200, disabled: !isCommunityAdmin}"
            @end="onListItemMove"
          >
            <v-layout
              v-for="(community, i) in chapterQuickLinks"
              :key="i"
              row
              class="chapter_quick_links__drag-div__row"
            >
              <v-flex xs1>
                <i class="fas fa-grip-vertical"></i>
              </v-flex>
              <v-flex xs9>
                <a
                  @click="openLink(community)"
                  class="network_page_related_community"
                  data-qe-id="open_community_url_anchor"
                  >{{ community.title }}</a
                >
              </v-flex>
              <v-flex xs2 class="chapter_quick_links__drag-div__actions">
                <i
                  class="fas fa-pencil-alt"
                  v-if="isCommunityAdmin"
                  @click="editChapterQuickLink(community.id)"
                  :data-qe-id="`sub-networks_${i}-edit_link`"
                  title="Edit"
                ></i>
                <i
                  class="fas fa-trash-alt"
                  v-if="isCommunityAdmin"
                  @click="deleteOpenDialog(community.id)"
                  :data-qe-id="`sub-networks_${i}-delete_link`"
                  title="Delete"
                ></i>
              </v-flex>
            </v-layout>
          </draggable>

          <v-layout v-if="isCommunityAdmin" text-xs-center mt-2>
            <v-flex>
              <v-btn
                @click="handleAddChapterQuickLink()"
                data-qe-id="add-communities_btn"
                class="primary_btn transparent"
              >
                <i class="fas fa-plus mr-2"></i>
                {{ chapterConstants.ADD_CHAPTER_QUICK_LINKS }}
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout
            v-if="maxLimitReachedDialog"
            column
            justify-center
            class="chapter_quick_links__delete__dailog"
            text-xs-center
          >
            <div>
              <p>{{ chapterConstants.MAX_LIMIT_REACHED_MESSAGE }}</p>
              <div>
                <v-btn
                    class="primary_btn theme--dark small"
                    data-qe-id="cancel_dialog_btn"
                    @click="maxLimitReachedDialog = false"
                >
                  {{chapterConstants.CLOSE}}
                </v-btn>
              </div>
            </div>
          </v-layout>

          <v-layout
            v-if="deleteDialog"
            column
            justify-center
            class="chapter_quick_links__delete__dailog"
            text-xs-center
          >
            <div>
              <p>{{ chapterConstants.DELETE_CONFIRMATION }}</p>
              <div>
                <v-btn
                    class="primary_btn transparent v-btn--flat theme--light small"
                    data-qe-id="cancel_dialog_btn"
                    @click="deleteDialog = false"
                >
                  {{chapterConstants.CANCEL}}
                </v-btn>
                <v-btn
                    class="primary_btn theme--dark small"
                    data-qe-id="save_dialog_btn"
                    :loading="isProcessing"
                    @click="deleteChapterQuickLink()"
                >
                  {{chapterConstants.OK}}
                </v-btn>
              </div>
            </div>
          </v-layout>
        </v-layout>

        <v-layout v-else column class="addeditcommunity pa-3">
          <v-form v-model="fieldsValid">
            <v-text-field
              v-model="newChapterQuickLink.title"
              :rules="titleRules"
              autofocus
              :placeholder="chapterConstants.TITLE_PLACEHOLDER"
            ></v-text-field>
            <v-text-field
              v-model="newChapterQuickLink.url"
              :rules="urlRules"
              :placeholder="chapterConstants.LINK_PLACEHOLDER"
            ></v-text-field>
          </v-form>
          <v-layout row wrap>
            <v-flex xs3>
              <v-btn
                @click="isAddRecord = false"
                data-qe-id="close_dialog_btn"
                class="primary_btn transparent small"
                >{{ appCommonConstants.CANCEL }}</v-btn
              >
            </v-flex>
            <v-flex xs9 text-xs-right>
              <v-btn
                v-if="!isEditRecord"
                @click="saveChapterQuickLink()"
                class="primary_btn small"
                data-qe-id="save_dialog_btn"
                :loading="isProcessing"
                :disabled="!formValid"
                >{{ appCommonConstants.SAVE }}</v-btn
              >
              <v-btn
                v-if="isEditRecord"
                @click="updateChapterQuickLink()"
                class="primary_btn small"
                data-qe-id="update_dialog_btn"
                :loading="isProcessing"
                :disabled="!formValid"
                >{{ appCommonConstants.UPDATE }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>


<script>
  import { storeAction } from "../../store/storeActions.constant";
  import { mapGetters, mapActions } from "vuex";
  import { storeGetters } from '../../store/storeGetters.constant';
  import { userRoles, appCommonConstants } from '@/components/appCommon.constants';
  import { networkConstants, chapterConstants } from "@/components/ChapterPage/communityCommon.constant";
  import draggable from 'vuedraggable';
  import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';


  export default {
      name: 'ChapterQuickLinks',
      components: {
          StatusOverlay,
          draggable,

      },
      data() {
          return {
              chapterConstants,
              networkConstants,
              userRoles,
              appCommonConstants,
              deleteDialog: false,
              isAddRecord: false,
              isEditRecord: false,
              isReordered: false,
              isReorder: false,
              isProcessing: false,
              fieldsValid: false,
              quickLinkId:'',
              maxLimitReachedDialog: false,
              newChapterQuickLink: {
              url: '',
              title: '',
              id:null,
              dateCreated:'',
              createdBy:''
          },
          titleRules: [
              v => !!v || networkConstants.errors.TITLE_IS_REQUIRED,
          ],
          urlRules: [
              v => !v || !!v.match(/(\S+\.[^/\s]+(\/\S+|\/|))/g) || networkConstants.errors.URL_LINK_IS_REQUIRED,
          ],
          };
      },
      created() {
          this.getChapterQuickLinks(this.$route.params.communityId);
      },
      methods: {
        ...mapActions({
          getChapterQuickLinks: `chapter/${storeAction.getChapterQuickLinks}`,
          createNewChapterQuickLink: `chapter/${storeAction.createChapterQuickLinks}`,
          modifyDisplayOrderChapterQuickLinks: `chapter/${storeAction.modifyDisplayOrderChapterQuickLinks}`,
        }),
        openLink(quickLink) {
          const appOrigin = window.location.origin;
          let target = '_blank';

          if (quickLink.url.includes(appOrigin) || this.isMobileAppBrowser) {
            target = '_self';
          }
          window.open(quickLink.url, target);
        },
        addNewChapterQuickLink() {
          this.isAddRecord = true;
          this.isEditRecord = false;
          this.newChapterQuickLink.title = '';
          this.newChapterQuickLink.url = '';
          this.newChapterQuickLink.displayOrder = this.chapterQuickLinks.length;
        },
        onListItemMove() {
          this.isProcessing = true;
          if (this.chapterQuickLinks) {
            const updatedContent = this.chapterQuickLinks.map((element, index) => {
              element.displayOrder = index + 1;
              return element;
            });
            const saveData = [...updatedContent];
            this.modifyDisplayOrderChapterQuickLinks(saveData)
              .then(() => {
                this.isProcessing = false;
              })
              .catch((err) => {
                this.isProcessing = false;
                console.error("err", err);
              });
          }

        },
        editChapterQuickLink(quickLinkId) {
          const chapterQuickLink = this.chapterQuickLinks.find(item => item.id === quickLinkId);
          this.newChapterQuickLink.title = chapterQuickLink.title;
          this.newChapterQuickLink.url = chapterQuickLink.url;
          this.newChapterQuickLink.displayOrder = chapterQuickLink.displayOrder;
          this.newChapterQuickLink.dateCreated = chapterQuickLink.dateCreated;
          this.newChapterQuickLink.createdBy = chapterQuickLink.createdBy;
          this.isAddRecord = true;
          this.isEditRecord = true;
          this.quickLinkId = quickLinkId;
        },
        saveChapterQuickLink() {
          this.isProcessing = true;
          if (!this.newChapterQuickLink.url.includes('http')) {
            this.newChapterQuickLink.url = `https://${this.newChapterQuickLink.url}`;
          }
          this.isProcessing = true;
          this.createNewChapterQuickLink({ ...this.newChapterQuickLink, isActive: true })
            .then(() => {
              this.newChapterQuickLink.url = '';
              this.newChapterQuickLink.title = '';
              this.newChapterQuickLink.id = null;
              this.newChapterQuickLink.dateCreated = '';
              this.newChapterQuickLink.createdBy = '';
              this.isAddRecord = false;
              this.isEditRecord = false;
            })
            .catch((error) => {
              console.error('Failed to create chapter quick link:', error);
            })
            .finally(() => {
              this.isProcessing = false;
            });
        },
        deleteOpenDialog(quickLinkId) {
                this.deleteDialog = true;
                this.quickLinkId = quickLinkId;
        },
        updateChapterQuickLink() {
          this.isProcessing = true;
          if (!this.newChapterQuickLink.url.includes('http')) {
            this.newChapterQuickLink.url = `https://${this.newChapterQuickLink.url}`;
          }
          this.createNewChapterQuickLink({ ...this.newChapterQuickLink, id: this.quickLinkId, isActive: true }).then(() => {
            this.newChapterQuickLink.url = '';
            this.newChapterQuickLink.title = '';
            this.newChapterQuickLink.id = null;
            this.newChapterQuickLink.dateCreated = '';
            this.newChapterQuickLink.createdBy = '';
            this.isAddRecord = false;
            this.isEditRecord = false;
          })
            .catch((error) => {
              console.error('Failed to create chapter quick link:', error);
            })
            .finally(() => {
              this.isProcessing = false;
            });
        },
        deleteChapterQuickLink() {
          this.isProcessing = true;
          this.createNewChapterQuickLink({ ...this.newChapterQuickLink, id: this.quickLinkId, isActive: false }).then(() => {
            this.newChapterQuickLink.url = '';
            this.newChapterQuickLink.title = '';
            this.newChapterQuickLink.id = null;
            this.isAddRecord = false;
            this.isEditRecord = false;
            this.deleteDialog = false;
          })
            .catch((error) => {
              console.error('Failed to create chapter quick link:', error);
            })
            .finally(() => {
              this.isProcessing = false;
            });
        },
        handleAddChapterQuickLink() {
          if (this.chapterQuickLinks.length >= 5) {
            this.maxLimitReachedDialog = true;
          } else {
            this.addNewChapterQuickLink();
          }
        },
      },
      computed: {
        ...mapGetters({
          chapterQuickLinks: `chapter/${storeGetters.chapterQuickLinks}`,
          isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
        }),
        formValid() {
          return this.fieldsValid && (this.newChapterQuickLink.title && this.newChapterQuickLink.url);
        },
      },
  };
</script>

<style lang="scss">
  @import "../../common/styles/_colors.scss";

  .chapter_quick_links {
      .v-tabs__item {
          color: $white;

          i {
              color: $white;
          }
      }

      &__drag-div {
          padding: 10px;
          max-height: 250px;
          overflow-y: auto;

          &__row {
              position: relative;
              border-bottom: 1px solid $ypo-medium-gray;
              padding: 10px 60px 10px 30px;
              transition: 0.3s ease all;

              a {
                  text-decoration: none;
                  font-size: 14px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: block;
                  overflow: hidden;

              }

              .fa-arrow-right {
                  position: absolute;
                  right: 5px;
                  top: 12px;
                  font-size: 18px;
                  color: $ypo-cta;
              }

              .fa-grip-vertical {
                  position: absolute;
                  left: 5px;
                  top: 15px;
                  color: $ypo-cta;
                  cursor: move;

              }

              &:hover {
                  .fa-arrow-right {
                      opacity: 0;
                  }

                  .chapter_quick_links__drag-div__actions {
                      opacity: 1;
                      visibility: visible;

                  }

              }

          }

          &__actions {
              position: absolute;
              opacity: 0;
              right: 6px;
              top: 10px;
              transition: 0.3s ease all;
              visibility: hidden;

              i {
                  margin-left: 10px;
                  cursor: pointer;
                  color: $ypo-cta;
              }
          }

      }

      &__delete__dailog {
          background-color: rgba($white, 0.9);
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          padding: 15px;
          border-radius: 3px;
          height: 100%;

          h4 {
              position: relative;
              padding-right: 23px;

              .close-btn {
                  position: absolute;
                  right: 0;
                  top: -7px;
                  margin: 0;
              }
          }

          p {
              margin: 20px 0;
          }

      }
  }
</style>
